import React, { useEffect, useRef, useState } from 'react';
import './Navbar.css';
import { withTranslation } from 'react-i18next';
import { NavLink, useHistory, useLocation } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import {Avatar, Backdrop, Box, Button, Fade, Grid, List, ListItem, Modal, Typography} from '@material-ui/core';
import i18n from '../../i18n';
import { useDispatch, useSelector } from "react-redux";
import { authActions } from "../../redux/actions";
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import {getChainName, getIcons, isValidBtcAddress, isValidDogeAddress} from "../../utils/Common";
import { isMobile } from 'react-device-detect';

import navIcon from "../../images/navigationBar/navLogo.png";
import connectedWallet from "../../images/navigationBar/connectedWallet.png";
import moreIcon from "../../images/navigationBar/moreIcon.png";
import connectWallet from "../../images/navigationBar/connectWallet.png";
import cnIcon from "../../images/navigationBar/ChinaIcon.png";
import enIcon from "../../images/navigationBar/USAIcon.png";
import useWindowDimensions from "../../utils/WindowDimensions";
import WalletModal from "../WalletModal";
import {isValidAddress} from "ethereumjs-util";
import Menu from "@material-ui/core/Menu";
import { useWalletStore } from '../../store/useStore'
import * as Url from '../../config/Url'

const loggedInIcon = 'https://cdn.swapallapp.com/l2/images/loggedInIcon.png'

let tempHeight = null;


function Navbar({ t, sendBackHeight, 
    walletModalOpen, closeWalletModal, openWalletModal,
 }) {
    const { height, width } = useWindowDimensions();
    const useStyles = makeStyles((theme) => ({
        bar: {
            background: 'yellow'
        },
        navbarDisplayFlex: {
            display: `flex`,
            justifyContent: `space-between`,
            backgroundColor: 'blue',
            width: '100%'
        },
        navDisplayFlex: {
            display: `flex`,
            justifyContent: `space-between`,
        },
        linkText: {
            textDecoration: `none`,
            textTransform: `uppercase`,
            color: `white`,
            alignSelf: 'center'
        },
        defaultFont: {
            fontWeight: '400', color: '#363636', fontFamily: 'Avenir', textTransform: 'none'
        },
        unselect: {
            textDecoration: `none`, display: 'flex', alignItems: 'center', justifyContent: 'center', marginLeft: 12, marginRight: 12, paddingLeft: 12, paddingRight: 12, fontWeight: '400', color: '#363636', fontFamily: 'Avenir', width: 80, height: 40

        },

        selected: {
            textDecoration: `none`,

            alignSelf: 'center',

            borderRadius: 8,
            backgroundColor: '#F8F8F8',
            color: '#251CFF',
            fontWeight: 'bold',
        },
        logo: {
            width: width > 1000 ? 200 : width * 0.2,
        },
        langBtn: {
            height: 30,
            alignSelf: 'center',
            background: 'transparent',
            color: 'white'
        },
        addrBtn: {
            height: 30,
            alignSelf: 'center',
            background: '#2435AC',
            color: 'white',
            fontSize: width > 350 ? 15 : '0.5rem'
        },
        modal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        paper: {
            backgroundColor: 'white',
            border: 'transparent',
            // boxShadow: theme.shadows[5],
            padding: theme.spacing(2, 4, 3),
            borderRadius: 20,
            textAlign: 'center'
        },
        walletBox: {
            padding: theme.spacing(2, 2),
            borderRadius: 5,
            cursor: 'pointer',
            '&:hover' : {
                backgroundColor: '#E0E0E0',
            }
        },
        walletIcon: {
            width: 50,
            marginLeft: 24,
            marginRight: 24,

        },
        externalLink: {
            textDecoration: 'none',
            '&:visited': {
                color: 'unset', // Prevent purple after click
            },
        }
    }));
    const classes = useStyles();

    const { address, setAddress, chainId, setChainId, network, setNetwork, pubKey, setPublicKey,
        walletDisconnected, setWalletDisconnected, dappConnected, setDappConnected, autoSign, setAutoSign,
        currentWallet, setWallet, startWatch, setStartWatch, button1, button2, setButton1, setButton2, setButton1Disabled, setButton2Disabled,
        button1Disabled, button2Disabled
    } = useWalletStore()
    const [open, setOpen] = useState(false)
    const [openMore, setOpenMore] = React.useState(false);
    const { loggedIn, registered, message, loading, authMsg } = useSelector(state => state.auth)
    const prevNavMessageRef = useRef();
    const prevLoggedIn = useRef(loggedIn)
    const history = useHistory();
    const location = useLocation()
    const dispatch = useDispatch();
    const [openMsgModal, setOpenMsgModal] = useState(false)
    const [blueHeader, setBlueHeader] = useState(false)

    const [anchorEl, setAnchorEl] = React.useState(null);
    const disconnectOpen = Boolean(anchorEl);
    const handleDisconnectClick = (event) => {
        setAnchorEl(event.currentTarget);

    };
    const handleCloseDisconnect = () => {
        setAnchorEl(null);
    };



    const handleOpenMsgModal = () => {
        setOpenMsgModal(true);
    };

    const handleCloseMsgModal = () => {
        setOpenMsgModal(false);
        dispatch(authActions.checkUser(address))
    };

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const changeLanguage = (e) => {
        let newLang = i18n.language === 'en' ? 'cn' : 'en'
        i18n.changeLanguage(newLang);
        localStorage.setItem('lng', newLang)
    }


    const navLinks = [
        // { title: loggedIn ? t('wallet') : t('home'), path: loggedIn ? `/wallet` : `/` },
        { title: t('home'), path: `/` },
        { title: t('l2Pools'), path: `/pool` },
        { title: t('explorer'), path: Url.EXPLORER_URL }
        // { title: t('IDO'), path: '/ido' },
        // { title: t('IDOInvite'), path: '/ido/invite' },
        // { title: t('dapp'), path: '/dapp' },
        // { title: t('wallet'), path: `/wallet` },
        // { title: t('vote'), path: '/vote' },
        // { title: "Layer 3", path: '/layer3' },
    ]

    const barRef = React.useRef(null);
    const prevAuthMsgRef = useRef();

    const switchAccount = async () => {
        await window.ethereum.request({
            method: 'wallet_requestPermissions',
            params: [{
                eth_accounts: {},
            }]
        }).then(res => {
            handleClose()
        })
    };

    const clear = () => {
        setChainId(0)
        setNetwork('')
    }



    function handleNewChain(chainId) {
        console.log('chainId changed !: ', chainId)
        setChainId(chainId)
    }

    function handleNewNetwork(networkId) {
        console.log('network changed !: ', networkId)
        setNetwork(networkId)
    }

    function handleNewAccounts(addr) {
        console.log('addr changed !: ', addr)
        let address = typeof addr === 'string' ? addr : addr.length > 0 ? addr[0] : ''
        if (address === '') {
            clear()
        } else {
            setAddress(address)
        }

    }

    useEffect(() => {
        if (barRef.current && tempHeight === null) {
            tempHeight = barRef.current.getBoundingClientRect().height;
            sendBackHeight(tempHeight)
        }
        return () => {
        }
    }, [])

    useEffect(() => {
        /**
         * imToken DApp browser
         */
        if (!!window.imToken) {
            setAddress(window.ethereum.selectedAddress)
            setChainId(window.ethereum.chainId)
            setNetwork(window.ethereum.networkVersion)
        }
        return () => {
        }

    }, window.imToken)

    useEffect(() => {
        if (prevNavMessageRef.current === '' && (message === 'Wrong network id.')) {
            handleOpenMsgModal()
        }

        prevNavMessageRef.current = message;
        return () => {
        }

    }, [message, width])

    useEffect(() => {
        if (prevAuthMsgRef.current === '' && authMsg === 'wrongNetwork') {
            handleOpenMsgModal()
        }
        prevAuthMsgRef.current = authMsg;
        return () => {
        }
    }, [authMsg])

    const anchorRef = React.useRef(null);
    const handleToggle = () => {
        setOpenMore((prevOpen) => !prevOpen);
    };

    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpenMore(false);
        }
    }

    const handleCloseMore = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpenMore(false);
    };


    useEffect(() => {
        setBlueHeader(history.location.pathname === '/ido' || history.location.pathname === '/ido/')
    }, [history, location])

    useEffect(() => {
        // console.log('we are here : ', prevLoggedIn.current, loggedIn)
        if (!prevLoggedIn.current && loggedIn) {
            if (walletModalOpen) {
                closeWalletModal()
            }
        }
        prevLoggedIn.current = loggedIn
        return () => {}
    }, [loggedIn])


    // useEffect(() => {
    //     console.log('chainId, network: ', chainId, network)
    //     handleNewChain(chainId)
    //     handleNewNetwork(network)
    // }, [chainId, network])

    return (
        <div style={{ zIndex: location.pathname.includes('/dapp') ? 111 : 'unset', }} ref={barRef}>
            <div style={{ flexDirection: 'column', justifyContent: 'space-between', height: width > 960 ? 100 : 70, alignItems: 'center' }}>
                <div style={{ background: location.pathname.includes('/dapp') ? 'transparent' : blueHeader ? '#F1F9FF' : 'unset', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', width: '100%', height: width > 960 ? 100 : 72 }}>
                    <div style={{ display: 'flex' }}>
                        {width > 960 ?
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', }}>

                                <Button onClick={() => { history.replace('/') }} aria-label="home" style={{ backgroundColor: "#251CFF", borderRadius: 0, height: 100, alignItems: 'center', justifyContent: 'center' }}>
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <img alt='' style={{ width: 72, marginLeft: 24, marginRight: 24 }} src={navIcon} />
                                        <Typography style={{ fontSize: 20, fontWeight: 900, color: 'white', textTransform: 'none', fontFamily: 'Avenir' }}>SonicEx</Typography>
                                    </div>
                                </Button>
                            </div>
                            :
                            null
                        }
                        <div style={{ display: 'flex', flexDirection: 'row', height: '50%', alignSelf: 'center', marginLeft: "4%" }}>
                            {
                                width > 960 ?
                                    <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        {navLinks.map(({ title, path }) => 
                                        
                                            title !== t('explorer') ? 
                                            (
                                                <NavLink to={path} key={title} className={classes.unselect}
                                                    InputProps={{ disableUnderline: true }}
                                                    activeClassName={classes.selected}
                                                    isActive={(match, location) => {
                                                        if (location.pathname === path) {
                                                            return true
                                                        } else if (location.pathname.includes('wallet') && path === '/wallet') {
                                                            return true
                                                        } else if (location.pathname.includes('swap') && path === '/swap') {
                                                            return true
                                                        } else {
                                                            return false
                                                        }
                                                    }}
                                                >
    
                                                    {title}
                                                </NavLink>
                                            ) : 
                                            <div className={classes.unselect}>
                                                <a href={path} target="_blank" className={classes.externalLink}>
                                                    {title}
                                                </a>
                                            </div>
                                        )}



                                        {width > 900 ?
                                            <Button style={{}}
                                                ref={anchorRef}
                                                aria-controls={openMore ? 'menu-list-grow' : undefined}
                                                aria-haspopup="true"
                                                onClick={handleToggle}
                                            >
                                                <Typography className={classes.defaultFont} >
                                                    {t("more")}
                                                </Typography>
                                            </Button>
                                            :
                                            null
                                        }


                                    </div>
                                    :
                                    <Button style={{ backgroundColor: 'transparent', height: '100%', borderRadius: 50, marginLeft: width < 900 ? 0 : 16 }}
                                        ref={anchorRef}
                                        aria-controls={openMore ? 'menu-list-grow' : undefined}
                                        aria-haspopup="true"
                                        onClick={handleToggle}
                                    >

                                        <img alt='' style={{ height: 32, width: 32 }} src={moreIcon} />
                                    </Button>
                            }

                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginRight: width > 900 ? 16 : 24, width: 340 }}>

                        {
                            width > 960 ?
                                <Button style={{ marginRight: 24 }}

                                    onClick={changeLanguage}
                                >

                                    <img alt='' src={i18n.language === 'en' ? cnIcon : enIcon} style={{ height: 18 }} />
                                    <Typography className={classes.defaultFont} style={{ fontSize: 16, marginLeft: 4 }}>
                                        {t('lang')}
                                    </Typography>

                                </Button>

                                :
                                null
                        }

                        <Button
                            style={{ backgroundColor: 'white', display: 'flex', flexDirection: 'row', marginRight: isMobile ? -8 : 24, borderRadius: 12 }}
                            id="wallet-button"
                            onClick={ address !== '' ? handleDisconnectClick : openWalletModal}
                            aria-controls={disconnectOpen ? 'disconnect-menu' : undefined}
                            aria-haspopup="true"
                        >
                            <img alt='' style={{ width: width > 960 ? 46 : 32, marginLeft: 0, marginRight: isMobile ? 0 : 8 }} src={registered ? connectedWallet : connectWallet} />
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: "center", alignItems: 'center', marginRight: isMobile ? 0 : 16 }}>
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                    {
                                        network !== '' ?
                                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: "flex-end", alignItems: 'center' }}>
                                                <Typography style={{ display: 'flex', fontSize: 12, color: '#8786A7', fontWeight: 'bold', justifyContent: 'baseline' }}>
                                                    {getChainName(network, chainId, t)}
                                                </Typography>
                                            </div>
                                            :
                                            null
                                    }
                                    <Typography style={{ fontSize: 12, color: '#251CFF', fontWeight: '600', marginTop: -3 }}>
                                        {
                                            /** registered ? Mar 1st 2024 - For demo purpose **/
                                            isValidBtcAddress(address) || isValidAddress(address) || isValidDogeAddress(address) ?
                                            isMobile || width < 500 ? '' :
                                                `${address.slice(0, 8)}...${address.slice(address.length - 3)}`
                                            :
                                            button1
                                        }
                                    </Typography>
                                </div>

                            </div>
                        </Button>
                        <Menu
                            id="disconnect-menu"
                            aria-labelledby="wallet-button"
                            keepMounted
                            anchorEl={anchorEl}
                            open={disconnectOpen}
                            onClose={handleCloseDisconnect}
                            getContentAnchorEl={null}
                            MenuListProps={{
                                'aria-labelledby': 'wallet-button',
                            }}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center',
                            }}
                        >
                            <MenuItem
                                style={{ backgroundColor: 'white', display: 'flex', flexDirection: 'row',  borderRadius: 12 }}
                                onClick={() => {
                                    clear()
                                    dispatch(authActions.dappDisconnect(dispatch, address, chainId, network, setAddress, setChainId, setNetwork, setPublicKey, setDappConnected, setWallet, setStartWatch, setWalletDisconnected))
                                    handleCloseDisconnect()
                                }}>
                                <Typography style={{ fontSize: width < 900 ? 12 : 16, color: '#251CFF', fontWeight: '600' }}>
                                    {t('disconnect')}
                                </Typography>
                            </MenuItem>
                        </Menu>
                        <div style={{ alignItems: 'center', justifyContent: 'center' }}>
                            <Popper open={openMore} anchorEl={anchorRef.current} role={undefined} transition>
                                {({ TransitionProps, placement }) => (
                                    <Grow
                                        {...TransitionProps}
                                        style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                                    >
                                        <Paper style={{ borderRadius: 12 }}>
                                            <ClickAwayListener onClickAway={handleCloseMore}>

                                                <MenuList style={{ zIndex: 9999999 }} autoFocusItem={openMore} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                                                    {
                                                        width <= 900 ?
                                                            <Typography className={classes.defaultFont} style={{ fontSize: 14, color: '#8B96A7', marginLeft: 22, marginTop: 16 }}>{t('navigation')}</Typography> : null
                                                    }

                                                    {
                                                        width <= 900 ?
                                                            navLinks.map(({ title, path }) => 

                                                               title !== t('explorer') ?

                                                                (<NavLink to={path} key={title} style={{
                                                                    height: '100%', textDecoration: `none`
                                                                }}
                                                                    InputProps={{ disableUnderline: true }}
                                                                    activeClassName={classes.selected}
                                                                    isActive={(match, location) => {
                                                                        if (location.pathname === path) {
                                                                            return true
                                                                        } else if (location.pathname.includes('') && path === '/') {
                                                                            return true
                                                                        } else {
                                                                            return false
                                                                        }
                                                                    }}
                                                                >
                                                                    <ListItem button style={{ height: '100%' }}>
                                                                        <Typography className={classes.defaultFont} style={{ fontSize: 16, fontWeight: 'bold', textTransform: 'none', marginLeft: 8, }}>
                                                                            {title}
                                                                        </Typography>

                                                                    </ListItem>
                                                                </NavLink>)
                                                                : 
                                                                (
                                                                    <a href={path} target="_blank" className={classes.externalLink}>
                                                                        <Typography className={classes.defaultFont} style={{ fontSize: 16, fontWeight: 'bold', textTransform: 'none', marginLeft: 8, paddingLeft: 16}}>
                                                                            {title}
                                                                        </Typography>
                                                                    </a>
                                                                )    
                                                            ) : null
                                                    }
                                                    {
                                                        width <= 900 ?
                                                            <Button onClick={changeLanguage} className={classes.defaultFont} style={{ minWidth: 0, minHeight: 0, fontSize: 16, fontWeight: 'bold', textTransform: 'none', marginLeft: 16, }}>
                                                                {t('lang')}
                                                            </Button>
                                                            :
                                                            null
                                                    }
                                                

                                                    {
                                                        width <= 900 ?
                                                            <Typography className={classes.defaultFont} style={{ fontSize: 14, color: '#8B96A7', marginLeft: 22, marginTop: 16 }}>{t('more')}</Typography> : null
                                                    }
                                                    {/* <MenuItem
                                                        onClick={() => {
                                                            i18n.language === 'cn' ?
                                                                window.open('https://SonicEx.zendesk.com/hc/zh-cn', '_blank')
                                                                :
                                                                window.open('https://SonicEx.zendesk.com/hc/en-ca', '_blank')
                                                        }}
                                                    >
                                                        <Typography className={classes.defaultFont} style={{ fontSize: 16, fontWeight: 'bold', textTransform: 'none', marginLeft: 8, }}>
                                                            {t('announcement')}
                                                        </Typography>
                                                    </MenuItem>

                                                    <MenuItem
                                                        onClick={() => {
                                                            i18n.language === 'cn' ?
                                                                window.open('https://docs.SonicEx.com/v/zhong-wen/', '_blank')
                                                                :
                                                                window.open('https://docs.SonicEx.com/', '_blank')
                                                        }}
                                                    >
                                                        <Typography className={classes.defaultFont} style={{ fontSize: 16, fontWeight: 'bold', textTransform: 'none', marginLeft: 8, }}>
                                                            {t('doc')}
                                                        </Typography>
                                                    </MenuItem>
                                                    <MenuItem
                                                        onClick={() => {
                                                            i18n.language === 'cn' ?
                                                                window.open(wpCN, '_blank')
                                                                : window.open(wpEN, '_blank')
                                                        }}
                                                    >
                                                        <Typography className={classes.defaultFont} style={{ fontSize: 16, fontWeight: 'bold', textTransform: 'none', marginLeft: 8, }}>
                                                            {t('whitePaper')}
                                                        </Typography>
                                                    </MenuItem>

                                                    <MenuItem
                                                        onClick={() => {
                                                            i18n.language === 'cn' ?
                                                                window.open('https://docs.SonicEx.com/v/zhong-wen/shen-ji/shen-ji-bao-gao', '_blank')
                                                                : window.open('https://docs.SonicEx.com/audit/audit-reports', '_blank')
                                                        }}
                                                    >
                                                        <Typography className={classes.defaultFont} style={{ fontSize: 16, fontWeight: 'bold', textTransform: 'none', marginLeft: 8, }}>
                                                            {t('audit')}
                                                        </Typography>
                                                    </MenuItem> */}

                                                    <MenuItem
                                                        onClick={() => { window.open('mailto:support@SonicEx.com') }}
                                                        style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', justifyItems: 'center' }}
                                                    >
                                                        <Typography className={classes.defaultFont} style={{ fontSize: 16, fontWeight: 'bold', textTransform: 'none', marginLeft: 8, textAlign: 'center' }}>
                                                            {t('contactUs')}
                                                        </Typography>
                                                    </MenuItem>
                                                </MenuList>
                                            </ClickAwayListener>
                                        </Paper>
                                    </Grow>
                                )}
                            </Popper>
                        </div>

                    </div>
                </div>
            </div>
            <Modal
                disablePortal
                disableEnforceFocus
                disableAutoFocus
                aria-labelledby="server-modal-title"
                aria-describedby="server-modal-description"
                className={classes.modal}
                open={open}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={open}>
                    <div style={{
                        backgroundColor: 'white', borderRadius: 16, width: width < 950 ? "91%" : 480, overflow: 'hidden', outline: 0, display: 'flex', alignItems: 'center', flexDirection: 'column'
                    }}>

                        <img alt='' src={loggedInIcon} variant="square" style={{ height: 66 * 1.2, width: 82 * 1.2, marginTop: 24 }} />

                        <Typography style={{ fontSize: 16, fontWeight: 'bold', marginTop: 8, color: '#8786A7' }}>
                            {loggedIn ? t('metamaskConnected') : t('metamaskLogin')}
                        </Typography>
                        <Typography style={{ fontSize: 12, fontWeight: 'bold', marginTop: -4, color: '#251CFF', marginBottom: 32 }}>
                            {address}
                        </Typography>


                        <Button style={{ height: 52, width: '100%', backgroundColor: '#251CFF', borderRadius: 0 }}
                            onClick={switchAccount} variant="contained">
                            <Typography style={{ fontSize: 16, fontWeight: 'bold', color: 'white' }}>
                                {t('switch')}
                            </Typography>
                        </Button>
                    </div>
                </Fade>
            </Modal>
            <WalletModal
                walletModalOpen={walletModalOpen}
                closeWalletModal={closeWalletModal}
                handleNewAccounts={handleNewAccounts}
                handleNewNetwork={handleNewNetwork}
                handleNewChain={handleNewChain}
                isMobile={isMobile}
            />

        </div>
    )
}

export default withTranslation()(Navbar);
